import cn from "classnames";

const Loading = ({ visible, inline }: { visible: boolean; inline?: boolean }) => (
  <div className={cn("loading", visible ? "visible" : "hidden", inline ? "inline" : "full")}>
    <div className="spinner" />
  </div>
);

export default Loading;
